import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.element.parentNode.parentNode.insertAdjacentHTML('beforeend', this.element.innerHTML)
  }
}
